export const SET_CONNECTED = 'setConnected'
export const SET_CURRENTPOINT = 'setCurrentPoint'
export const SET_PLAYING = 'setPlaying'
export const SET_STARTTIMER = 'setStartTimer'
export const SET_CRASHED = 'setCrashed'
export const SET_HISTORY = "setHistory"
export const SET_BETS = "setBets"
export const SET_CURRENTBET = "setCurrentBet"
export const SET_CHAT = "setChat"
export const ADD_CHAT_MESSAGE = "addChatMessage"
export const SET_TIMER_WAITING = "setTimerWaiting"
